import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';
import ImporterStatsSearchResultV from '../view/recordm.view.searchresult.importer.stats.js';
import Ps from '../recordm.permissions.js';
import RecordmImporterSummaryStatM from "../model/recordm.importer.model.stat.summary.js";
import SearchVisM from '../model/recordm.model.searchvisualization.js';

import UriBuilder from '../helpers/module.uribuilder.js';

import { sprintf } from 'sprintf-js';
import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

const ImporterStatsSearchResultP = function(core, searchM, visualizationGroupM, $container) {

    const dummyStatM = new RecordmImporterSummaryStatM(core),
        _entityKey = dummyStatM.getEntityKey(),
        _loadingKey = core.getLoadingKey();

    const hasViewDetailsPerm = core.hasPermission("module:view:importer-stats-details"),
        _hasPermToShareViews= core.hasPermission(Ps.VIEW_SHARE);

    let _statsM = {},         // to keep the stats Models that we're currently showing
        _totalResults = 0,
        _activeVisualizationM = new SearchVisM(core, dummyStatM),
        _activeVisualizationId;

    const conf = {
        rowsPerPage: searchM.getRowsPerPage(),
        columns: {
            all: _activeVisualizationM.getColumns(),
            visible: _activeVisualizationM.getVisibleColumns()
        },
        autoHeight: true
    };

    const _updateSearchResultViewColumns = function() {
        const fields = dummyStatM.getSearchableFields();

        const columns = utils.clone(fields);
        for (let i = 0; i < columns.length; i++) {
            // copy the formatters, so that they keep the original scope (from before beeing cloned)
            if (columns[i].formatter) {
                columns[i].formatter = fields[i].formatter;
            }
        }

        conf.columns = {
            all: columns,
            visible: _activeVisualizationM.getVisibleColumns(),
            sort: _activeVisualizationM.getSortedColumn()
        };

        _searchResultView.setColumns(conf.columns);
    };

    const onVisualizationSettingsChanged = function(){
        _activeVisualizationM.updateTemporarySettingsCache();
    };

    const _searchResultView = new ImporterStatsSearchResultV(core, $container, conf, {
        moreRecordsClick: function() {
            core.showLoading(_loadingKey, 'Search Results Load More Start');

            searchM.loadMoreData();
        },
        getName: function() {
            return dummyStatM.getName();
        },
        getStatM: function(statId) {
            return _statsM[_entityKey + ":" + statId];
        },
        columnsVisibilityChanged: function(columns) {

            let columnsVisibilityChanged = false;

            columns.forEach(function(column) {

                    const changedColumn = dummyStatM.getSearchableField(column.fieldName);

                    if (changedColumn) {
                        _activeVisualizationM.setColumnVisibility(changedColumn, column.visibility);
                        onVisualizationSettingsChanged();

                        columnsVisibilityChanged = true;
                    }
                }
            );

            if (columnsVisibilityChanged) {
                _searchResultView.setViewStatus(
                    core.translateString("recordm.search", "visualization.column-visibility-changed")
                );

                _updateSearchResultViewColumns();
            }
        },
        columnWidthChanged: function(fieldName, width) {
            _activeVisualizationM.setColumnWidth(fieldName, width);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.column-width-changed")
            );
        },
        columnOrderChanged: function(columns) {
            _activeVisualizationM.setColumnOrder(columns);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.column-order-changed")
            );

        },
        sortColumns: function(fieldId, ascending) {
            core.showLoading(_loadingKey, 'Search Results Sort Start');

            searchM.sort(fieldId, ascending);

            _activeVisualizationM.setSortedColumn(fieldId, ascending);
            onVisualizationSettingsChanged();

            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.sort-changed")
            );
        },
        selectionChanged: function(){
           // do nothing, just for compat
        },
        saveCurrentView: function() {
            _searchResultView.askForViewName(_activeVisualizationM.getName());
        },
        viewNameConfirmed: function(name) {
            let existingVisualizationM = visualizationGroupM.getByName(name);

            if (existingVisualizationM) {
                if (!existingVisualizationM.isOwnedByUser()) {
                    ui.notification.showError(
                        core.translateString("recordm.search", "visualization.system-visualization-change-not-allowed")
                    );
                    return;
                }

                existingVisualizationM = _activeVisualizationM;

                _setActiveView(existingVisualizationM);
            } else {
                _activeVisualizationM.setName(name);
            }

            _searchResultView.resetViewStatus();
            core.showLoading(_loadingKey, 'save view');

            visualizationGroupM.save(_activeVisualizationM);

            _activeVisualizationM.clearTemporarySettingsCache();
        },
        activateView: function(viewId, viewLabel) {
            const existingVisualizationM = visualizationGroupM.get(viewId);

            let requiresNewSearch = false,
                currentSortedColumn,
                nextSortedColumn;

            if (!existingVisualizationM) {
                ui.notification.showError(
                    sprintf(core.translateString("recordm.search", "visualization.error-saving"), viewLabel)
                );
            } else {
                existingVisualizationM.resetTemporarySettingsToOriginal();

                currentSortedColumn = _activeVisualizationM.getSortedColumn();
                nextSortedColumn = existingVisualizationM.getSortedColumn();

                //   Situations that requires a new search:
                //   * no sort defined -> sort defined
                //   * sort defined -> no sort defined
                //   * sort column changes

                requiresNewSearch =
                    // * no sort defined -> sort defined
                    (!currentSortedColumn && nextSortedColumn) ||
                    //   * sort defined -> no sort defined
                    (currentSortedColumn && !nextSortedColumn) ||
                    //   * sort column changes
                    (currentSortedColumn && nextSortedColumn && (
                        currentSortedColumn.column !== nextSortedColumn.column ||
                        currentSortedColumn.ascending !== nextSortedColumn.ascending));

                if (requiresNewSearch) {
                    // update the search as soon as possible
                    searchM.sort(
                        nextSortedColumn ? nextSortedColumn.column : undefined,
                        nextSortedColumn ? nextSortedColumn.ascending : undefined
                    );
                }

                _activeVisualizationM = existingVisualizationM.getCopy();

                _searchResultView.resetViewStatus();
                _setActiveView(_activeVisualizationM);
                _updateSearchResultViewColumns();
            }
        },
        deleteView: function(viewId) {
            const existingVisualizationM = visualizationGroupM.get(viewId);

            ConfirmDialog(core, {
                    message: sprintf(
                        core.translateString("recordm.search", "visualization.delete-question"),
                        existingVisualizationM.getName()
                    ),
                    confirmBtnLabel: core.translateString("recordm.search", "action.delete"),
                    confirmBtnClass: "btn-danger"
                },
                {
                    requestConfirmed: function() {
                        core.showLoading(_loadingKey, 'delete view');
                        visualizationGroupM.deleteView(parseInt(viewId, 10));
                    }
                });

        },
        shareView: function(viewId) {
            const visualizationM = visualizationGroupM.get(viewId);

            if(visualizationM){
                core.showLoading(_loadingKey, 'share view');
                visualizationM.share();
            }
        },
        unshareView: function(viewId) {
            const existingVisualizationM = visualizationGroupM.get(viewId);

            if(existingVisualizationM) {
                core.showLoading(_loadingKey, 'unshare view');
                existingVisualizationM.unshare();
            }
        },
        getFieldValue: function(resultData, fieldDef) {
            //We do not want to get the values from the Checkboxes or "Actions" columns
            if (fieldDef.entityField) {
                return resultData[fieldDef.field];
            } else {
                return undefined;
            }
        }
    });

    const _showData = function(stats) {

        const statsM = stats;

        const newStatsM = {},
            // a Latch that will fire after all the entityMs are available
            modelLoadLatch = new utils.CountdownLatch(statsM.getNumStats(), function() {
                // Release previous laaded instances
                _releaseStatsM(_statsM);

                // Update our indexedInstancesM
                _statsM = newStatsM;

                // Update the UI
                _updateViewData();

            }, "model load");

        _totalResults = statsM.getTotal();

        // we trigger loading the models for all the IDs that we received,
        // and subscribe to the updates
        statsM.getAllStats().forEach(function(statM) {
            const key = statM.getModelKey();

            // if not already loaded then subscrive for updates and deletes
            if (!_statsM[key]) {
                core.subscribe(statM.getUpdateEventName(), _updateViewData);
                core.subscribe(statM.getDeleteEventName(), _onStatDeleted);
            }

            if(hasViewDetailsPerm){
                statM.setUri("#/" + UriBuilder.buildUriForImportDetailsWithSimpleSearch(statM.getId(), "*"));
            }

            newStatsM[key] = statM;

            modelLoadLatch.countDown("model:loaded:" + key);
        });

        core.publish('rm-stats-search:results-ready');
    };

    const _updateViewData = function() {
        // everything's ready, let's show the new results
        const statsData = [];

        utils.forEachOwn(_statsM, function(key) {
            statsData.push(_statsM[key].getFullData());
        });

        _searchResultView.setTotalMatchingResults(
           _totalResults,
           // HACK: sabemos que o ES devolve 10000 se tiver mais, assumimos que ninguém alterou a conf
           _totalResults != 10000
        );
        _searchResultView.showData(statsData);
    };

    const _onStatDeleted = function(e, data) {
        const key = (data.entityKey + ":" + data.id),
            deletedStatM = _statsM[key];

        searchM.removeFromSearchResult(deletedStatM);

        core.unsubscribe(deletedStatM.getDeleteEventName(), _onStatDeleted);
        core.unsubscribe(deletedStatM.getUpdateEventName(), _updateViewData);

        delete _statsM[key];

        deletedStatM.release();

        _updateViewData();
    };

    const _releaseStatsM = function(statsM) {
        utils.forEachOwn(statsM, function(key) {
            statsM[key].release();
        });
    };

    const _updateViews = function() {

        const currentVisualization = visualizationGroupM.get(
            _activeVisualizationId || _activeVisualizationM.getId()
        );

        _activeVisualizationId = undefined;

        if (currentVisualization) {
            _setActiveView(currentVisualization.getCopy());

            //only cache original if there isn't one (or else the original would be overwritten by the current view)
            if(!currentVisualization.hasOriginalSettingsCached()){
                currentVisualization.cacheOriginalSettings();
            }
        }

        const views = {
            active: {
                id: _activeVisualizationM.getId(),
                label: _activeVisualizationM.getName()
            },
            all: []
        };

        views.all = visualizationGroupM.getVisualizations().map(function(entry) {
            const viewOwner = entry.getOwner(),
                isOwnedByUser = entry.isOwnedByUser(),
                isShared = entry.isShared(),
                showOwner = !isOwnedByUser && !entry.isSystemSetting(),
                canShare = _hasPermToShareViews && isOwnedByUser;


            return {
                id: entry.getId(),
                label: entry.getName(),
                canDelete: isOwnedByUser,
                canShare: canShare,
                isShared: isShared,
                showOwner: showOwner,
                owner: viewOwner
            };
        });

        _searchResultView.setViewList(views);
        _updateSearchResultViewColumns();

        core.hideLoading(_loadingKey, 'update views');
    };

    const _updateViewList = function() {
        if(_activeVisualizationM.hasTemporarySettingsCached()){
            _searchResultView.setViewStatus(
                core.translateString("recordm.search", "visualization.has-unsaved-changes")
            );
        }else{
            _searchResultView.resetViewStatus();
        }
    };

    const _onViewDeleted = function(e, data) {
        const viewId = data.viewId;

        _searchResultView.removeView(viewId);

        // If the selected view is the same as the one beeing deleted
        // then unselect that view.
        if (_activeVisualizationM.getId() === viewId) {
            _activeVisualizationM.clearTemporarySettingsCache();
            _setActiveView(new SearchVisM(core, dummyStatM));
        }

        core.hideLoading(_loadingKey, 'delete view');
    };

    const _onViewShared = function(e, data){
        _onViewShareChanged(data.viewId, true);

        core.hideLoading(_loadingKey, 'share view');
    };

    const _onViewUnshared = function(e, data){
        _onViewShareChanged(data.viewId, false);

        core.hideLoading(_loadingKey, 'unshare view');
    };

    const _onViewShareChanged = function(viewId, isShared){
        _searchResultView.changeViewShareOption(viewId, isShared);
    };

    const _hideLoadingIndicator = function() {
        core.hideLoading(_loadingKey, 'Search Results end');
    };

    const _setActiveView = function(viewM) {
        _activeVisualizationM = viewM;

        _searchResultView.setActiveView({
            id: _activeVisualizationM.getId(),
            label: _activeVisualizationM.getName()
        });

        core.publish("recordm:search-view-changed:" + _entityKey, viewM.getId());
    };

    const _showSearchError = function(data) {
        const errorMsg = core.translateString("recordm.error.codes", "generic." + data.status.toString()) ||
                         core.translateString("recordm.error.codes", "generic.0");

        ui.notification.showError(errorMsg);
    };

    const _onSearchFinished = function(e, data) {
        _hideLoadingIndicator();

        if(data.stats){
            _showData(data.stats);
        } else {
            _showSearchError(data);
        }
    };

    const _subscribeEvents = function() {
        core.subscribe("recordm:search:finished", _onSearchFinished);

        core.subscribe("recordm:settings:" + _entityKey + ":views", _updateViewList);
        core.subscribe("recordm:settings:" + _entityKey + ":view-deleted", _onViewDeleted);
        core.subscribe("recordm:settings:" + _entityKey + ":view-shared", _onViewShared);
        core.subscribe("recordm:settings:" + _entityKey + ":view-unshared", _onViewUnshared);
        core.subscribe("recordm:settings:" + _entityKey + ":view-saved", _updateViews);
    };

    const _unsubscribeEvents = function() {
        core.unsubscribe("recordm:search:finished", _onSearchFinished);

        core.unsubscribe("recordm:settings:" + _entityKey + ":views", _updateViewList);
        core.unsubscribe("recordm:settings:" + _entityKey + ":view-deleted", _onViewDeleted);
        core.unsubscribe("recordm:settings:" + _entityKey + ":view-shared", _onViewShared);
        core.unsubscribe("recordm:settings:" + _entityKey + ":view-unshared", _onViewUnshared);
        core.unsubscribe("recordm:settings:" + _entityKey + ":view-saved", _updateViews);
    };

    return {
        init: function(query, activeVisualizationId) {
            _subscribeEvents();

            _searchResultView.start();

            core.showLoading(_loadingKey, 'ImporterStatsSearchResultP init');

            if (query === undefined) {
                _searchResultView.showWatermark();

            } else {
                _searchResultView.setSearchInProgressMode();
            }

            // Store the ID to load the visualization when available
            _activeVisualizationId = activeVisualizationId;

            _updateViews();
            _updateViewList();
        },
        resume: function() {
            _subscribeEvents();

            _searchResultView.start();

            if (searchM.getCurrentQuery()) {
                _updateViewData();
            }
        },
        pause: function() {
            _unsubscribeEvents();

            _searchResultView.stop();
        },
        destroy: function() {
            _unsubscribeEvents();
            _activeVisualizationM.clearTemporarySettingsCache();
            _searchResultView.stop();

            //release models
            _releaseStatsM(_statsM, []);
            _statsM = {};
        },
        prepareView: function() {
            _searchResultView.refreshGrid();
        }
    };
};

export default ImporterStatsSearchResultP;
